import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />

        {/* Header Cơ Cấu Giải Thưởng */}
        <div
          className="flex flex-col max-w-[1000px] mx-auto lg:flex-row justify-center items-center md:p-10 p-5 mt-2 mb-4 w-full h-auto min-h-[280px] relative bg-white bg-white/95 border-2 border-solid shadow shadow-primary md:pb-8 md:pt-4 rounded-2xl"
          style={{
            background: '#FFFFFF80',
            borderColor: '#26A9E0',
            borderRadius: '1.5rem'
          }}
        >
          <div className="md:max-w-[250px] max-w-[220px]">
            <img
              src="/assets/images/cocau/cocau.png"
              alt=""
              className="w-full h-full object-contain"
            />
          </div>

          {/* Bảng Cơ Cấu Giải Thưởng từ Figma */}
          <div className="w-full mx-auto lg:mt-0 px-2 mt-3 lg:ml-5">
            <table
              className="w-full text-center"
              style={{ borderCollapse: 'separate', borderSpacing: 0 }}
            >
              <thead>
                <tr>
                  <th className="bg-[#26A9E0] text-white text-[16px] sm:text-[18px] md:text-[20px] font-semibold py-2 px-2 rounded-tl-[9px]">
                    Cấp độ VIP
                  </th>
                  <th className="bg-[#26A9E0] text-white text-[16px] sm:text-[18px] md:text-[20px] font-semibold py-2 px-2 rounded-tr-[9px]">
                    Tiền Thưởng
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-transparent">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#26A9E0] py-3 px-2">
                    VIP 0
                  </td>
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">
                    29
                  </td>
                </tr>
                <tr className="bg-[#F6F6F6]">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#26A9E0] py-3 px-2">
                    VIP 1 - VIP 5
                  </td>
                  <td
                    className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2"
                    style={{ opacity: 0.9 }}
                  >
                    99
                  </td>
                </tr>
                <tr className="bg-transparent">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#26A9E0] py-3 px-2">
                    VIP 6 - VIP 10
                  </td>
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">
                    299
                  </td>
                </tr>
                <tr className="bg-[#F6F6F6]">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#26A9E0] py-3 px-2">
                    VIP 11 - VIP 20
                  </td>
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">
                    999
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <MatchResult />
      </div>
    </div>
  );
};

export default PrizeStructure;
